export default __webpack_public_path__ + "static/ios15-with-chrome-560d040eabea790f087cafd5dfcfdf86.jpg";